@if (!shouldHide()) {
  <div class="loading-screen" animate.enter="fade-in" animate.leave="fade-out">
    <div class="loading-content">
      <div class="loading-logo">
        <img src="assets/images/logos/f4rm-logo-text.png" alt="F4rm.io Logo" width="350" height="109" />
      </div>
      <div class="loading-message">{{ message() }}</div>
      <div class="loading-spinner"></div>
      <div class="loading-dots">
        <div class="loading-dot"></div>
        <div class="loading-dot"></div>
        <div class="loading-dot"></div>
      </div>
    </div>
  </div>
}